"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  margin: -32px 0 -16px 0; /* FIXME: \n    Ugly fix to override Heading style created by CardHeader\n    disableTypography or titleTypographyProps doesn't works\n  */\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 8px 12px;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var CardHeader = (0, _styledComponents.default)(_core.CardHeader)(_templateObject(), function (props) {
  return props.theme.palette.grey[100];
}, function (props) {
  return props.theme.palette.grey[300];
});
var Title = (0, _styledComponents.default)(_Typography.default)(_templateObject2(), function (props) {
  return props.theme.typography.fontWeightSemiBold;
});

var Card = function Card(_ref) {
  var children = _ref.children,
      title = _ref.title,
      subheader = _ref.subheader,
      props = _objectWithoutProperties(_ref, ["children", "title", "subheader"]);

  return _react.default.createElement(_core.Card, props, _react.default.createElement(CardHeader, {
    title: _react.default.createElement(Title, {
      variant: "subtitle1"
    }, title),
    subheader: _react.default.createElement(_Typography.default, {
      variant: "body2"
    }, subheader)
  }), children);
};

Card.defaultProps = {
  children: null,
  subheader: ''
};
var _default = Card;
exports.default = _default;